// @ts-nocheck
import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import {
    onlyUnique, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function DataFilter({
    setCurrentPage, 
    setFilter, 
    curFilter, 
    defaultFilter, 
    items,
    dataFrame,
    width,
    minWidth, 
    buttonClassName = "headerButton",
    applyOnSearch = false,
}){
    const [showFilter, setShowFilterForm] = useState(false);
    const [draftFilter, setDraftFilter] = useState(curFilter);
    const activeFilter = applyOnSearch?draftFilter:curFilter;
    const updateFilter = nextFilter => {
        if(applyOnSearch){
            setDraftFilter(nextFilter);
        }else{
            setFilter(nextFilter);
            setCurrentPage(1);
        }
    };
    const applyFilter = () => {
        setFilter(draftFilter);
        setCurrentPage(1);
        setShowFilterForm(false);
    };
    const clearFilter = () => {
        setDraftFilter(defaultFilter);
        setFilter(defaultFilter);
        setCurrentPage(1);
    };
    return (
        <>
        <button
            type = "button"
            className = {buttonClassName}
            style = {{
                backgroundColor: 
                buttonClassName === "headerButton" &&
                Object.entries(curFilter).some(([key, value]) => defaultFilter[key] !== value)?
                "rgb(0,123,255)"
                :undefined
            }} 
            onClick = {() => {
                setDraftFilter(curFilter);
                setShowFilterForm(true);
            }}
        >
            Filter
            {buttonClassName !== "headerButton" && Object.entries(curFilter).some(([key, value]) => defaultFilter[key] !== value)?
            <span
                children = "on"
                className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle"
                style = {{minWidth: "2.4em"}}
            />:null}
        </button>
        {showFilter?
        <Modal
            touchOutsideClose = {true}
            closeIt = {() => setShowFilterForm(false)}
            title = "Filter"
            width = {width}
            minWidth = {minWidth}
        >
            <div className = "mt-3 mb-3">
                <button
                    children = "Clear Filter"
                    type = "button"
                    className = "btn btn-secondary"
                    onClick = {() => {
                        clearFilter();
                    }}
                />
                {applyOnSearch?
                <button
                    children = "Search"
                    type = "button"
                    className = "btn btn-primary ms-3"
                    onClick = {applyFilter}
                />:null}
            </div>
            {dataFrame.map((item, itemIndex) => 
            item.type === "select"?
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
               <label className = "fw-bold text-nowrap" htmlFor = {item.key}>{item.label}:</label>
                <select
                    id = {item.key}
                    className = "form-control flex-grow-1 ms-3"
                    value = {activeFilter[item.key]}
                    onChange = {e => {
                    updateFilter({...activeFilter, [item.key]: e.currentTarget.value});
                }}>
                    {item.options.map((opt, optIndex) => <option key = {optIndex} value = {opt.value}>{opt.label}</option>)}
                </select>
                {
                activeFilter[item.key] !== defaultFilter[item.key]?
                <button type = "button" className = "noButtonStyle ms-2" onClick = {() => {updateFilter({...activeFilter, [item.key]: defaultFilter[item.key]})}}>❌</button>:
                null
                }
            </div>
            :item.type === "date"?
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <span className = "fw-bold text-nowrap">{item.label}:</span>
                <label htmlFor = {item.key + "Min"} className = "mb-0 ms-3">after:</label>
                <input
                    id = {item.key + "Min"}
                    type = "date"
                    min = "1900-01-01"
                    max = {activeFilter[item.key + "Max"] || "2999-12-31"}
                    className = "form-control flex-grow-1 ms-3"
                    value = {activeFilter[item.key + "Min"] ?? ""}
                    onChange = {e => {
                        updateFilter({...activeFilter, [item.key + "Min"]: e.currentTarget.value});
                    }}
                />
                <label htmlFor = {item.key + "Max"} className = "mb-0 ms-3">before:</label>
                <input
                    id = {item.key + "Max"}
                    type = "date"
                    min = {activeFilter[item.key + "Min"] || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control flex-grow-1 ms-3"
                    value = {activeFilter[item.key + "Max"] ?? ""}
                    onChange = {e => {
                        updateFilter({...activeFilter, [item.key + "Max"]: e.currentTarget.value});
                    }}
                />
                {
                activeFilter[item.key + "Max"] || activeFilter[item.key + "Min"]?
                <button className = "noButtonStyle ms-2" onClick = {() => {updateFilter({...activeFilter, [item.key + "Min"]: defaultFilter[item.key + "Min"], [item.key + "Max"]: defaultFilter[item.key + "Max"]})}}>❌</button>:
                null
                }
            </div>
            :item.type === "number"?
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <span className = "fw-bold text-nowrap">{item.label}:</span>
                <label htmlFor = {item.key + "Min"} className = "mb-0 ms-3">min:</label>
                <input
                    id = {item.key + "Min"}
                    type = "number"
                    min = "1900-01-01"
                    max = {activeFilter[item.key + "Max"] || "2999-12-31"}
                    className = "form-control flex-grow-1 ms-3"
                    value = {activeFilter[item.key + "Min"] ?? ""}
                    onChange = {e => {
                        updateFilter({...activeFilter, [item.key + "Min"]: e.currentTarget.value});
                    }}
                />
                <label htmlFor = {item.key + "Max"} className = "mb-0 ms-3">max:</label>
                <input
                    id = {item.key + "Max"}
                    type = "number"
                    min = {activeFilter[item.key + "Min"] || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control flex-grow-1 ms-3"
                    value = {activeFilter[item.key + "Max"] ?? ""}
                    onChange = {e => {
                        updateFilter({...activeFilter, [item.key + "Max"]: e.currentTarget.value});
                    }}
                />
                {
                activeFilter[item.key + "Max"] || activeFilter[item.key + "Min"]?
                <button className = "noButtonStyle ms-2" onClick = {() => {updateFilter({...activeFilter, [item.key + "Min"]: defaultFilter[item.key + "Min"], [item.key + "Max"]: defaultFilter[item.key + "Max"]})}}>❌</button>:
                null
                }
            </div>
            :<div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <label className = "fw-bold text-nowrap" htmlFor = {item.key}>{item.label}:</label>
                <input
                    id = {item.key}
                    list = {item.key + " list"}
                    type = "text"
                    className = "form-control flex-grow-1 ms-3"
                    value = {activeFilter[item.key]}
                    onChange = {e => {
                        updateFilter({...activeFilter, [item.key]: e.currentTarget.value});
                    }}
                    autoComplete = {item.autoComplete ?? "off"}
                />
                {!item.noList?
                <datalist id = {item.key + " list"} value = {activeFilter[item.key]}>
                    {items.map(itemObj => itemObj[item.key]).filter(onlyUnique).map((itemContent, itemContentIndex) => <option key = {itemContentIndex}>{itemContent}</option>)}
                    {item.extraData?.map((itemContent, itemContentIndex) => <option key = {itemContentIndex}>{itemContent}</option>)}
                </datalist>
                :<></>}
                {activeFilter[item.key] !== defaultFilter[item.key]?
                <button type = "button" className = "noButtonStyle ms-2" onClick = {() => {updateFilter({...activeFilter, [item.key]: defaultFilter[item.key]})}}>❌</button>:
                null
                }
            </div>)}
            <div className = "mt-3 mb-3">
                <button
                    children = "Clear Filter"
                    type = "button"
                    className = "btn btn-secondary"
                    onClick = {() => {
                        clearFilter();
                    }}
                />
                {applyOnSearch?
                <button
                    children = "Search"
                    type = "button"
                    className = "btn btn-primary ms-3"
                    onClick = {applyFilter}
                />:null}
            </div>
        </Modal>
        :null}
        </>
    )
}
